import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Typography } from "@digital-services/ui";

import ApplicationIcon from "@icons/application.svg?react";
import OrganizationIcon from "@icons/organization.svg?react";

import { QuickAccessTile } from "./QuickAccessTile";

export const QuickAccessPanel: FunctionComponent = () => {
  const { t } = useTranslation(undefined, {
    keyPrefix: "dashboard.quick-access"
  });
  const { t: tCommon } = useTranslation();

  return (
    <div className="flex flex-col" data-testid="quick-access-panel">
      <Typography variant="sectionTitle">{t("section_title")}</Typography>
      <div className="flex gap-10">
        <QuickAccessTile
          id="organizations"
          icon={<OrganizationIcon />}
          href="/organizations"
          title={tCommon("organizations.nav_item.label")}
        />
        <QuickAccessTile
          id="applications"
          icon={<ApplicationIcon />}
          href="/applications"
          title={tCommon("applications.nav_item.label")}
        />
      </div>
    </div>
  );
};
